var _defs, _rect, _rect2, _circle, _g, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAssistantButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1024,
    height: 1024,
    viewBox: "0 0 1024 1024",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "bgGlow",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(512 470) rotate(90) scale(520)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#536890"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#263459"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#111827"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "panel",
    x1: 155,
    y1: 80,
    x2: 880,
    y2: 940,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#61709A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#334268"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B2542"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "robotShell",
    x1: 295,
    y1: 270,
    x2: 710,
    y2: 705,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#F4F6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7C9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "face",
    x1: 340,
    y1: 410,
    x2: 685,
    y2: 650,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#617EA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9CAFE0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cyan",
    x1: 355,
    y1: 430,
    x2: 700,
    y2: 700,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42E6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7D8CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "swoosh",
    x1: 190,
    y1: 705,
    x2: 875,
    y2: 530,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A855F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#5B6CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#35E6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "antenna",
    x1: 470,
    y1: 145,
    x2: 555,
    y2: 260,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDB7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#6BDFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D75FF"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "softShadow",
    x: 110,
    y: 70,
    width: 820,
    height: 900,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 26,
    stdDeviation: 35,
    floodColor: "#030712",
    floodOpacity: 0.38
  })), /*#__PURE__*/React.createElement("filter", {
    id: "glow",
    x: 100,
    y: 90,
    width: 850,
    height: 820,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 14,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "blur"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1024,
    height: 1024,
    rx: 220,
    fill: "url(#bgGlow)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 86,
    y: 76,
    width: 852,
    height: 872,
    rx: 158,
    fill: "url(#panel)",
    stroke: "#8BA0D6",
    strokeOpacity: 0.42,
    strokeWidth: 3
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 512,
    cy: 515,
    r: 360,
    fill: "#0D1B3D",
    opacity: 0.22
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#softShadow)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M199 604C230 748 394 812 572 791C733 771 842 671 887 513C874 696 727 846 536 862C352 878 206 782 199 604Z",
    fill: "url(#swoosh)",
    opacity: 0.95
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219 628C278 738 426 783 585 757C715 735 817 660 866 536",
    stroke: "#D7F7FF",
    strokeOpacity: 0.38,
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M813 330C824 370 834 380 874 391C834 402 824 413 813 452C802 413 792 402 752 391C792 380 802 370 813 330Z",
    fill: "#A9E6FF",
    opacity: 0.92
  }), /*#__PURE__*/React.createElement("path", {
    d: "M813 355C819 377 825 383 847 390C825 397 819 403 813 425C807 403 801 397 779 390C801 383 807 377 813 355Z",
    fill: "#DDF7FF",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 270,
    cy: 535,
    rx: 72,
    ry: 91,
    fill: "url(#robotShell)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 754,
    cy: 535,
    rx: 72,
    ry: 91,
    fill: "url(#robotShell)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288 456C267 508 267 561 292 620",
    stroke: "#9AA4FF",
    strokeWidth: 6,
    opacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M736 456C757 508 757 561 732 620",
    stroke: "#9AA4FF",
    strokeWidth: 6,
    opacity: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 497,
    y: 240,
    width: 30,
    height: 86,
    rx: 15,
    fill: "url(#antenna)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 512,
    cy: 205,
    r: 50,
    fill: "url(#antenna)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 492,
    cy: 181,
    rx: 18,
    ry: 10,
    transform: "rotate(-35 492 181)",
    fill: "white",
    opacity: 0.85
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254 518C254 381 365 270 502 270H522C659 270 770 381 770 518C770 655 659 720 522 720H502C365 720 254 655 254 518Z",
    fill: "url(#robotShell)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285 518C285 397 383 301 504 301H520C641 301 739 397 739 518C739 639 641 688 520 688H504C383 688 285 639 285 518Z",
    stroke: "#FFFFFF",
    strokeOpacity: 0.7,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 329,
    y: 409,
    width: 366,
    height: 232,
    rx: 96,
    fill: "url(#face)",
    stroke: "#E8EDFF",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 343,
    y: 423,
    width: 338,
    height: 204,
    rx: 84,
    fill: "#23395F",
    opacity: 0.28
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389 523C394 487 450 487 455 523",
    stroke: "url(#cyan)",
    strokeWidth: 19,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569 523C574 487 630 487 635 523",
    stroke: "url(#cyan)",
    strokeWidth: 19,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476 568C496 594 528 594 548 568",
    stroke: "url(#cyan)",
    strokeWidth: 17,
    strokeLinecap: "round"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 86,
    y: 76,
    width: 852,
    height: 872,
    rx: 158,
    stroke: "#111827",
    strokeOpacity: 0.35,
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssistantButton);
export default __webpack_public_path__ + "static/media/assistant-button.14606880b6f7938f770fe18daf42902d.svg";
export { ForwardRef as ReactComponent };